<template>
    <div>
        <div class="col-lg-12 mb-4">
            <div class="applicant-nav-tabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" v-for="(tab,index) in tabs">
                        <a
                            :class="[`nav-link `, {'active': activeTabIndex === index}]"
                            :id="`tab-${index}`"
                            data-toggle="tab"
                            :href="`#${tab}`"
                            role="tab"
                            aria-controls="home"
                            aria-selected="false"
                            @click="setActiveTab(tab)"
                        >
                            {{ tab }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="tab-content" id="myTabContent">

                    <div v-for="(tab,index) in tabs"
                         :class="[`tab-pane fade`, {'show active': activeTabIndex === index}]"
                         :id="tab"
                         role="tabpanel"
                         :aria-labelledby="`tab-${index}`"
                    >
                        <component
                            :is="getComponentName(tab)"
                            :isMasterAdminComponent="true"
                            :userInfo="user"
                            :user-id="user.id"
                            :viewAdminsNotes="viewAdminsNotes"
                            :editingNote="editingNote"
                            :viewRates="viewRates"
                        ></component>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeePersonal from "../../../AppUser/resources/js/EmployeeAdmin/EmployeePersonal.vue";
import Availability from "./Tabs/Availability.vue";
import Attachments from "./Tabs/Attachments.vue";
import CallOut from "./Tabs/CallOut.vue";
import Notes from "./Tabs/Notes.vue";
import History from "./Tabs/History.vue";
import SiteBans from "./Tabs/SiteBans.vue";
import Uniforms from "./Tabs/Uniforms.vue";
import Status from "./Tabs/Status.vue";
import TabsHandler from "../../../../../resources/js/mixins/TabsHandler";



export default {
    name: 'ApplicantTabsContainer',
    mixins: [TabsHandler],
    props: {
        user: Object,
        currentTab: String,
        viewAdminsNotes: Boolean,
        editingNote: Boolean,
        viewRates: Boolean,

    },
    components: {
        EmployeePersonal,
        Availability,
        Attachments,
        CallOut,
        Notes,
        History,
        SiteBans,
        Uniforms,
        Status
    },
    data() {
        return {
            selectedTab: null,
            activeTabIndex: 0,
            tabs: [
                'Stages/Progress',
                'Personal',
                'Availability',
                'Notes',
                'Attachments',
                'Uniforms',
                'Call Out',
                'Site Bans',
                'History',
            ]
        }
    },
    mounted() {
        this.getActiveTab();
    }
}

</script>

<style scoped>

</style>
